import axiosPost from "./axiosPost";

export const RNServicioGet = async (servicioCod, credentials) => {
    const body = {
        service: "RNUsuarioRolGet",
        params: {
            merchantId: credentials.merchantId,
            servicioHooliCod: servicioCod,
        },
    };

    const result = await axiosPost(body, credentials);
    return result;
};
